import { render, staticRenderFns } from "./QueryTool.vue?vue&type=template&id=0be437c0&"
import script from "./QueryTool.vue?vue&type=script&lang=js&"
export * from "./QueryTool.vue?vue&type=script&lang=js&"
import style0 from "./QueryTool.vue?vue&type=style&index=0&id=0be437c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports